import styles from '../../assets/styles/PayBills/PayBills.module.scss';
import { MimaButton, MimaText } from '../../components';
import SuccessImg from '../../assets/img/success.png';
import React from 'react';

function Success({ closeModal }) {
	return (
		<div className={styles.success}>
			<img
				src={SuccessImg}
				className={styles.airtimes__success}
				alt="Airtime success"
			/>
			<MimaText mb={3} mt={2}>
				Purchase Successful
			</MimaText>
			<MimaButton title="Continue" onClick={closeModal} />
		</div>
	);
}

export default Success;
